<rwidget-schedule-route-stop-details [routeId]="routeId" [stopId]="stopId" [directionId]="directionId">
</rwidget-schedule-route-stop-details>
